import { formatDate } from '@/helpers/formatDate'

export const modifyInvoiceTags = (invoice) => {
  if (invoice.invoiceFactoring) {
    invoice.factoringContact = invoice.invoiceFactoring.contact
    invoice.factoringReferences = invoice.invoiceFactoring.assignmentReference
    invoice.factoringPaymentData = invoice.invoiceFactoring.payment
    if (invoice.factoringPaymentData) {
      invoice.factoringPaymentData.map(paymentData => {
        paymentData.paymentDate = formatDate(paymentData.dueDate)
        paymentData.paymentMethod = paymentData.meansType
        delete paymentData.dueDate
        delete paymentData.meansType
        if (paymentData.accountDebited) {
          paymentData.ibanDebited = paymentData.accountDebited.iban
          delete paymentData.accountDebited
        }
        if (paymentData.accountCredited) {
          paymentData.ibanCredited = paymentData.accountCredited.iban
          delete paymentData.accountCredited
        }
      })
    }
    invoice.factoringTransferDocuments = invoice.invoiceFactoring.assignmentDocuments
    if (invoice.factoringTransferDocuments) {
      invoice.factoringTransferDocuments.map(transferDocument => {
        transferDocument.documentNature = transferDocument.documentCharacter
        transferDocument.representationType = transferDocument.representationIdentity
        transferDocument.reference = transferDocument.repository.reference
        transferDocument.repositoryName = transferDocument.repository.repositoryName
        transferDocument.url = transferDocument.repository.url
        delete transferDocument.repository
        delete transferDocument.documentCharacter
        delete transferDocument.representationIdentity
      })
    }
  }
  return invoice
}
